<form #form="ngForm" (ngSubmit)="onSubmit(form.value)" action="/simple-search" class="form-inline d-flex justify-content-center search-form" method="get">
    <div class="input-group input-group-lg">
        <!-- Si hay un botón adicional antes del input -->
        <div *ngIf="showScopeSelector" class="input-group-prepend">
            <button class="btn btn-uner-reverse" type="button" (click)="openScopeModal()"
                    [ngbTooltip]="dsoNameService.getName(selectedScope | async)">
                {{dsoNameService.getName(selectedScope | async) || ('search.form.scope.all' | translate)}}
            </button>
        </div>
        <input type="text" [(ngModel)]="query" name="query" class="form-control"
               attr.aria-label="{{ searchPlaceholder }}" [attr.data-test]="'search-box' | dsBrowserOnly"
               [placeholder]="searchPlaceholder" maxlength="200" size="50" title="Buscar en RID-UNER">
        <div class="input-group-append">
            <button type="submit" class="btn-uner-search-home">
                <span class="fas fa-search"></span>
            </button>
        </div>
    </div>
</form>
